import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiAgreeToOlInfoSharingConsentRequest,
  DefaultApiGetOlInfoSharingConsentRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getOlInfoSharingConsent = async (
  instance: AxiosInstance,
  params: DefaultApiGetOlInfoSharingConsentRequest
) => {
  return await userApiDefaultApiFactory(instance).getOlInfoSharingConsent(
    params
  )
}

export const agreeToOlInfoSharingConsent = async (
  instance: AxiosInstance,
  params: DefaultApiAgreeToOlInfoSharingConsentRequest
) => {
  return await userApiDefaultApiFactory(instance).agreeToOlInfoSharingConsent(
    params
  )
}

// Do Not Remove this line ===@import api client===
